export default function useLocalStorage() {
  function setItem(key, item) {
    localStorage.setItem(`aryeo-${key}`, JSON.stringify(item))

    return item
  }

  function getItem(key, defaultValue = null) {
    try {
      const value = localStorage.getItem(`aryeo-${key}`)
      return value === null ? defaultValue : JSON.parse(value)
    } catch (e) {
      return setItem(key, defaultValue)
    }
  }

  return {
    getItem,
    setItem,
  }
}
